import request from './request';

export default {
  getStaffTypes: () => request.easytip({
    method: 'get',
    url: '/v1/public/handbook/staffTypes',
    auth: false,
  }),
  getVersion: () => request.easytip({
    method: 'get',
    url: '/v1/public/handbook/versions',
    auth: false,
  }),
  getCountries: (params) => request.easytip({
    method: 'get',
    url: '/v4/handbook/country',
    params,
  }),
  getRemoveReasons: () => request.easytip({
    method: 'get',
    url: '/v3/handbook/workplaces/removeReasons',
  }),
  getFeeTypes: () => request.easytip({
    method: 'get',
    url: '/v4/handbook/platformFeeType',
  }),
  getTimezones: (params) => request.easytip({
    method: 'get',
    params,
    url: '/v4/handbook/timezones',
  }),
  getPlatformCommissionLevels: (params) => request.easytip({
    method: 'get',
    url: '/v4/handbook/platform-commission-levels',
    params,
  }),
  getPlatformFeeDefaults: (params) => request.easytip({
    method: 'get',
    url: '/v4/handbook/platform-fee-defaults',
    params,
  }),
};
